import { QueryKey } from '@tanstack/react-query'

import { queryClient } from '@/components/providers/tanstack-query-provider/tanstack-query-provider.constants'

// NOTE: This utility will be used to "properly" invalidate queries with filters and `keepPreviousData` util from tanstack-query
// Problem is that if we use `keepPreviousData` util, it will not reset the query data if the query is already in cache.
// That's why we invalidate the current query, so it will be refetched/recached as well as reset all the previous `'inactive'` queries.
// Hence, all the cached `'inactive'` queries will be recached properly and preserved with `keepPreviousData`
export const resetQueries = async (...queries: QueryKey[]) => {
  await Promise.all(
    queries.flatMap((queryKey) => [
      queryClient.invalidateQueries({ queryKey }),
      queryClient.resetQueries({ queryKey, type: 'inactive' }),
    ]),
  )
}
